var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { classNames } from './utils';
const highlightCardVariants = cva('highlight-card', {
    variants: {
        selected: { true: 'highlight-card-selected' },
        elevate: { true: 'highlight-card-elevate' },
    },
});
/** A bordered card that turns brand-tinted on hover, on focus and while selected. */
export default function HighlightCard(_a) {
    var { selected = false, elevate = false, asChild = false, className } = _a, props = __rest(_a, ["selected", "elevate", "asChild", "className"]);
    const Comp = asChild ? Slot : 'div';
    return (_jsx(Comp, Object.assign({ className: classNames(highlightCardVariants({ selected, elevate }), className) }, props)));
}
